import React from 'react';

/**
 * FeedbackStatusBadge - Generisk badge för feedback-status
 * Visar "Ej svarat", "Svarat" eller "Feedback OK" med färgkodning
 */
const FeedbackStatusBadge = ({ anyNeedsReply, statusText }) => {
  // Använd statusText om den finns, annars fallback till gammal logik
  const label = statusText || (anyNeedsReply ? 'Ej svarat' : 'Svarat');
  
  // Färgkodning baserat på status
  let badgeClass, dotClass;
  if (label === 'Ej svarat') {
    badgeClass = 'bg-red-100 text-red-800';
    dotClass = 'bg-red-500';
  } else if (label === 'Feedback OK') {
    badgeClass = 'bg-blue-100 text-blue-800';
    dotClass = 'bg-blue-500';
  } else {
    badgeClass = 'bg-green-100 text-green-800';
    dotClass = 'bg-green-500';
  }

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${badgeClass}`}>
      <span className={`w-2 h-2 rounded-full ${dotClass}`}></span>
      {label}
    </span>
  );
};

export default FeedbackStatusBadge;

